import {postJson, post} from './http'
const baseUrl = '/api/capwhale'
// 董秘会员信息
export const getAccountDmInfo = v => postJson(`${baseUrl}/center/dm/getAccountDmInfo`, v.data, v.success, v.error)
// 提交会员认证信息
export const submitAccountVerify = v => postJson(`${baseUrl}/center/dm/submitAccountVerify`, v.data, v.success, v.error)
// 提交董秘会员交费支付请求
export const uploadDMMemberPayInfo = v => post(`${baseUrl}/pay/uploadDMMemberPayInfo`, v.data, v.success, v.error)
// 查询通用支付结果
export const queryOrderPayResultCommon = v => post(`${baseUrl}/pay/queryOrderPayResultCommon`, v.data, v.success, v.error)